export const MAX_TEXTAREA_LENGTH = 10000
export const MAX_INPUT_LENGTH = 100
